import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Добавление слов", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "profile__nosections"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Вы еще не создали ни один раздел, или ваши слова уже есть во всех ваших разделах", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropList = _resolveComponent("DropList")!
  const _component_CreateFolder = _resolveComponent("CreateFolder")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onOnsuccess: _ctx.sendSection }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      (!_ctx.isLoaderItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.foldersList != null)
              ? (_openBlock(), _createBlock(_component_DropList, {
                  key: 0,
                  list: _ctx.foldersList,
                  onSetItem: _ctx.saveSection
                }, null, 8, ["list", "onSetItem"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_CreateFolder, { class: "profile__nosections-create" })
                ]))
          ]))
        : (_openBlock(), _createBlock(_component_Loader, { key: 1 }))
    ]),
    acceptButton: _withCtx(() => [
      _createTextVNode("Добавить")
    ]),
    _: 1
  }, 8, ["onOnsuccess"]))
}